import * as React from "react";
import classnames from "classnames";
import { Price } from "../../../Price/Price.js";
const PriceWithAffix = ({
  className,
  pricePrefix,
  priceSuffix,
  ...priceProps
}) => {
  return /* @__PURE__ */ React.createElement("span", { className: classnames("price-with-affix", className) }, pricePrefix, /* @__PURE__ */ React.createElement(Price, { ...priceProps }), priceSuffix);
};
export {
  PriceWithAffix
};
//# sourceMappingURL=PriceWithAffix.js.map
